/** @jsxImportSource ../../i18n */
import React from 'react';

export const ChartTooltip = ({ active, payload, label, labelFormatter, valueFormatter, nameFormatter }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="min-w-[9rem] rounded-control border border-line-strong bg-surface-3/95 px-3 py-2.5 shadow-pop backdrop-blur-md">
      {label !== undefined && label !== null && (
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-fg-subtle">{labelFormatter ? labelFormatter(label) : label}</p>
      )}
      <div className="mt-1.5 space-y-1">
        {payload.map((entry) => (
          <div key={entry.dataKey || entry.name} className="flex items-center gap-2 text-sm">
            <span aria-hidden="true" className="h-2 w-2 flex-shrink-0 rounded-full" style={{ backgroundColor: entry.payload?.color || entry.color || entry.stroke }} />
            {nameFormatter && <span className="text-fg-muted">{nameFormatter(entry.name, entry)}</span>}
            <span className="num ml-auto font-semibold text-fg">{valueFormatter ? valueFormatter(entry.value, entry) : entry.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
